// extracted by mini-css-extract-plugin
export var actualite = "detailsActu-module--actualite--5bf7d";
export var actualiteContentFooter = "detailsActu-module--actualite-content-footer--098f1";
export var actualiteContentFooterBack = "detailsActu-module--actualite-content-footer-back--9cf52";
export var actualiteImg = "detailsActu-module--actualite-img--11442";
export var actualiteTags = "detailsActu-module--actualite-tags--588cd";
export var actualiteTaxo = "detailsActu-module--actualite-taxo--864fd";
export var actualiteTitle = "detailsActu-module--actualite-title--79ac3";
export var pageActu = "detailsActu-module--page-actu--b0ee5";
export var pageActuAdditionalInfos = "detailsActu-module--page-actu-additional-infos--0ab41";
export var socialPanelContainer = "detailsActu-module--social-panel-container--9d675";